export default __webpack_public_path__ + "static/media/overdue.9595a286.svg";